import { fileUpload, getRequest, postRequest } from './request'
// 机构列表
export function merchantLists(params){
  return getRequest("/business/institution/list",
      params
)
}
// 机构创建
export function merchantAdd(params){
  return postRequest("/business/institution/add",
      params
)
}
// 机构删除
export function merchantRemove(params){
  return getRequest("/business/institution/delete",
      params
)
}
// 获取商户搜索框列表
export function merchantSearch(params){
  return getRequest("/business/all",
      params
)
}
// 机构拖动排序
export function merchantResort(params){
  return postRequest("/business/institution/drag",
      params
)
}